export default "__VITE_ASSET__f534f715__"